export const timeTypes = {
  HOURS: 'hours',
  MINUTES: 'minutes'
}
